<script setup lang="ts">
defineProps<{
  config: {
    label: string
    value: string
  }
}>()
</script>

<template>
  <div class="text-center p-4">
    <div class="text-sm uppercase text-muted-foreground">{{ config.label }}</div>
    <div class="text-4xl font-bold mt-2">{{ config.value }}</div>
  </div>
</template>
